<template>
<!-- =========================================================== -->
<!-- Use CSS w3schools for MENU-->
<!-- =========================================================== -->
  <div class="w3-bar w3-blue" v-if="globalUserID>0" hidden>
    <a href="#" class="w3-bar-item w3-button p-0"><router-link class="nav-link" to="/Home"><span class="w3-text-yellow"> Home</span></router-link></a>
    <!-- <a href="#" class="w3-bar-item w3-button"></a> -->
    <div class="w3-dropdown-hover">
      <button class="w3-button">Master</button>
      <div class="w3-dropdown-content w3-bar-block w3-card-4">
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/MBranchs">รายชื่อสาขา</router-link></a>
        <hr class="dropdown-divider">
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/MRoom">ห้องตรวจ</router-link></a>
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/MTests">เทสตรวจ</router-link></a>
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/MTestsuits">ชุดเทสตรวจ</router-link></a>
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/MPropack">แพคเกจชุดตรวจ</router-link></a>
        <hr class="dropdown-divider">
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/MPatients">รายชื่อคนไข้</router-link></a>
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/MClinics">คลินิก/โรงพยาบาล/บริษัท</router-link></a>
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/MClinicsRemote" title="๊User/Password สำหรับคลินิกต้นทางรีโมทดูผลแล็บ"
            v-show="globalCorpInfo.PackageType==2">
            Users คลินิกต้นทางรีโมทดูผลแล็บ</router-link>
        </a>
        <hr class="dropdown-divider">
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/MPayments" title="อาทิ เงินสด, โอนเข้าบช., QR-Code">ช่องทางการรับชำระเงิน</router-link></a>
      </div>
    </div>
    <div class="w3-dropdown-hover">
      <button class="w3-button">Daily</button>
      <div class="w3-dropdown-content w3-bar-block w3-card-4">
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/LabCreate">สร้างใบสั่งตรวจใหม่</router-link></a>
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/LabResult">ป้อนผลแล็บ</router-link></a>
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/LabApprove">อนุมัติผลแล็บ</router-link></a>
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/LabPrint">พิมพ์ผลแล็บ</router-link></a>
        <div class="dropdown-divider" v-show="globalCorpInfo.PackageType==2"></div>
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/LabRelease" v-show="globalCorpInfo.PackageType==2">
        อนุญาติให้คลินิกต้นทางเข้าถึงใบสั่งตรวจ <i class="fa fa-rss"></i></router-link></a>
      </div>
    </div>
    <div class="w3-dropdown-hover">
      <button class="w3-button">Billing</button>
      <div class="w3-dropdown-content w3-bar-block w3-card-4">
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/LabPaidCash">รับชำระรายการเงินสด</router-link></a>
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/LabPaidCredit">รับชำระรายการเครดิต</router-link></a>
        <div class="dropdown-divider"></div>
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/RcptCreate">ใบเสร็จรับเงิน</router-link></a>
      </div>
    </div>
    <div class="w3-dropdown-hover">
      <button class="w3-button">Reports</button>
      <div class="w3-dropdown-content w3-bar-block w3-card-4">
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/RepLabStatus">รายงานสถานะใบสั่งตรวจ</router-link></a>
        <div class="dropdown-divider"></div>
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/RepPatSummary">รายงานประวัติการตรวจของคนไข้</router-link></a>
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/RepLastLabOfPat">ผลการตรวจ 5 ครั้งล่าสุดภายใน 180 วัน</router-link></a>
        <div class="dropdown-divider"></div>
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/RepSumTestsuit">สรุปยอดขายชุดตรวจรายเดือน</router-link></a>
        <div class="dropdown-divider"></div>
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/RBillNote" title="ดึงเฉพาะประเภทเครดิตที่ค้างชำระ">สรุปรายการเครดิตค้างชำระ (แจ้งหนี้)</router-link></a>
      </div>
    </div>
    <div class="w3-dropdown-hover">
      <button class="w3-button">System</button>
      <div class="w3-dropdown-content w3-bar-block w3-card-4">
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/Setting">กำหนดกลุ่มและผู้ใช้งานระบบ</router-link></a>
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/Setting2">ตั้งค่าระบบ</router-link></a>
        <div class="dropdown-divider"></div>
        <a href="#" class="w3-bar-item w3-button p-0"><router-link class="dropdown-item" to="/about">About</router-link></a>
      </div>
    </div>
  </div>
<!-- =========================================================== -->
<!-- Use CSS Bootstarp for MENU-->
<!-- =========================================================== -->
  <div class="container-fluid"  v-if="globalUserID>0">
      <nav class="navbar navbar-expand-lg navbar-dark " style="background-color:CornflowerBlue;">
      <div class="container">
          <a class="navbar-brand" href="#">
              <img src="../assets/logo.png" alt="" width="30" height="30" class="d-inline-block ">
            <b> <span class="ms-2">LAB<span class="text-warning">SMART</span>  </span></b>
          </a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarColor01" aria-controls="navbarColor01" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarColor01">
          <ul class="navbar-nav me-auto">
              <li class="nav-item active">
                  <router-link class="nav-link" to="/Home">Home</router-link>
                  <span class="visually-hidden">(current)</span>
              </li>
              <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Master</a>
                  <div class="dropdown-menu">
                      <router-link class="dropdown-item" to="/MBranchs">รายชื่อสาขา</router-link>
                      <div class="dropdown-divider"></div>
                      <router-link class="dropdown-item" to="/MRoom">ห้องตรวจ</router-link>
                      <router-link class="dropdown-item" to="/MTests">เทสตรวจ</router-link>
                      <router-link class="dropdown-item" to="/MTestsuits"><b>ชุดเทสตรวจ</b></router-link>
                      <router-link class="dropdown-item" to="/MPropack" title="จัดแพคเกจโปรโมชั่นการตรวจ"> แพคเกจชุดตรวจ</router-link>
                      <router-link class="dropdown-item" to="/MSpecimens">สิ่งที่ส่งตรวจ</router-link>
                      <div class="dropdown-divider"></div>
                      <router-link class="dropdown-item" to="/MPatients">รายชื่อคนไข้</router-link>
                      <router-link class="dropdown-item" to="/MClinics" title="รายชื่อหน่วยงานต้นทางที่ส่งคนไข้มา">คลินิก/โรงพยาบาล/บริษัท</router-link>
                      <router-link class="dropdown-item" to="/MClinicsRemote" title="๊User/Password สำหรับคลินิกต้นทางรีโมทดูผลแล็บ"
                          v-show="globalCorpInfo.PackageType==2">
                          <i class="fa fa-rss me-2"></i>คลินิกต้นทางรีโมทดูผลแล็บ  <span class="badge bg-warning"><i class="fa fa-star"></i></span>
                      </router-link>
                      <div class="dropdown-divider"></div>
                      <router-link class="dropdown-item" to="/MPayments" title="อาทิ เงินสด, โอนเข้าบช., QR-Code">ช่องทางการรับชำระเงิน</router-link>
                      <router-link class="dropdown-item" to="/MRemarks">หมายเหตุ</router-link>
                  </div>
              </li>
              <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Daily</a>
                  <div class="dropdown-menu">
                      <router-link class="dropdown-item text-info" to="/LabCreate">สร้างใบสั่งตรวจใหม่</router-link>
                      <router-link class="dropdown-item" to="/LabCoverSheet" v-if="globalCorpInfo.StatusStep==0">พิมพ์ใบนำส่ง Cover Sheet</router-link>
                      <div class="dropdown-divider" v-if="globalCorpInfo.StatusStep==0"></div>
                      <router-link class="dropdown-item text-primary" to="/LabReceive" v-if="globalCorpInfo.StatusStep==0">ห้องแล็บรับ Specimen</router-link>
                      <router-link class="dropdown-item" to="/LabWorkSheet" v-if="globalCorpInfo.StatusStep==0">พิมพ์ใบเวิร์คชีท Work Sheet</router-link>
                      <div class="dropdown-divider"></div>
                      <router-link class="dropdown-item text-warning" to="/LabResult" v-if="(globalUserPosition==='MT')">ป้อนผลแล็บ</router-link>
                      <router-link class="dropdown-item text-danger" to="/LabApprove" v-if="(globalUserPosition==='MT')">อนุมัติผลแล็บ</router-link>
                      <router-link class="dropdown-item" to="/LabPrint">พิมพ์ผลแล็บ</router-link>
                      <div class="dropdown-divider"></div>
                      <router-link class="dropdown-item" to="/LabRelease"
                          v-show="globalCorpInfo.PackageType==2">
                          <i class="fa fa-rss me-2"></i>อนุญาติให้คลินิกต้นทางเข้าถึงใบสั่งตรวจ  <span class="badge bg-warning"><i class="fa fa-star"></i></span>
                      </router-link>
                      <div class="dropdown-divider"></div>
                      <router-link class="dropdown-item" to="/RepDshSummary">กระดานสรุปยอด</router-link>
                  </div>
              </li>
              <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Billing</a>
                  <div class="dropdown-menu">
                      <router-link class="dropdown-item" to="/LabPaidCash" >รับชำระรายการเงินสด</router-link>
                      <router-link class="dropdown-item" to="/LabPaidCredit" >รับชำระรายการเครดิต</router-link>
                      <div class="dropdown-divider"></div>
                      <router-link class="dropdown-item" to="/RcptCreate" >ใบเสร็จรับเงิน</router-link>
                  </div>
              </li>
              <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Reports</a>
                  <div class="dropdown-menu">
                      <router-link class="dropdown-item" to="/RepLabStatus">รายงานสถานะใบสั่งตรวจ</router-link>
                      <div class="dropdown-divider"></div>
                      <router-link class="dropdown-item" to="/RepPatSummary" >รายงานประวัติการตรวจของคนไข้</router-link>
                      <router-link class="dropdown-item" to="/RepLastLabOfPat" >ผลการตรวจ 5 ครั้งล่าสุดภายใน 180 วัน</router-link>
                      <div class="dropdown-divider"></div>
                      <router-link class="dropdown-item" to="/RepSumTestsuit" >สรุปยอดขายชุดตรวจรายเดือน</router-link>
                      <div class="dropdown-divider"></div>
                      <router-link class="dropdown-item" to="/RBillNote" title="ดึงเฉพาะประเภทเครดิตที่ค้างชำระ">สรุปรายการเครดิตค้างชำระ (แจ้งหนี้)</router-link>
                  </div>
              </li>
              <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">System</a>
                  <div class="dropdown-menu">
                      <router-link class="dropdown-item" to="/Setting">กำหนดกลุ่มและผู้ใช้งานระบบ</router-link>
                      <router-link class="dropdown-item" to="/Setting2">ตั้งค่าระบบ</router-link>
                      <div class="dropdown-divider"></div>
                      <router-link  class="dropdown-item" to="/about">About</router-link >
                  </div>
              </li>
          </ul>
          </div>
      </div>
      <div class="btn-group d-flex justify-content-end btn-sm " role="group">
          <button id="btnGroupDrop1" type="button" :title="globalUserName + ' (' + globalUserPosition + ')'"
              class="btn btn-outline dropdown-toggle me-3" data-bs-toggle="dropdown" aria-expanded="false">
              {{globalUserOfficialName}}
          </button>
          <ul class="dropdown-menu" aria-labelledby="btnGroupDrop1">
          <li><router-link class="dropdown-item" to="/UserChgpwd">เปลี่ยนรหัสผ่าน</router-link></li>
          </ul>
      </div>
      </nav>
  </div>
</template>

<script>
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalBranchID,
      globalUserID,
      globalUserName,
      globalUserOfficialName,
      globalUserPosition,
      globalCorpInfo
    }
  },
  name: 'HeaderMenu',
  components: {

  }
}
</script>
